module.exports = __webpack_public_path__ + "static/media/30OIOS3.0c310e04.jpg";